import React, { useEffect, useState } from 'react'
import { orderBy } from 'lodash'
import { IMiner, IMinerNode } from '@/types/miner.interface'
import { useTranslations } from 'next-intl'

import { Select, Stack } from '@chakra-ui/react'
import FacilityMobileDetailCard from './FacilityMobileDetailCard'

type Props = {
  items: IMinerNode[]
}

const FacilityDetailCard = function ({ items }: Props) {
  const t = useTranslations()
  const [hardwares, setHardwares] = useState<IMinerNode[][] | IMinerNode[]>(
    {} as IMinerNode[][] | IMinerNode[]
  )
  const [sort, setSort] = useState({
    key: 'minerModelHashratePerTerahash',
    order: 'asc',
  })

  const sortOptions = [
    {
      name: `${t('hardware-list.filter-selector-options.cost-asc')}`,
      filter: {
        key: 'productListingPrice',
        order: 'asc',
      },
    },
    {
      name: `${t('hardware-list.filter-selector-options.cost-desc')}`,
      filter: {
        key: 'productListingPrice',
        order: 'desc',
      },
    },
    {
      name: `${t('hardware-list.filter-selector-options.online-date-asc')}`,
      filter: {
        key: 'hostedTargetOnlineDate',
        order: 'asc',
      },
    },
    {
      name: `${t('hardware-list.filter-selector-options.online-date-desc')}`,
      filter: {
        key: 'hostedTargetOnlineDate',
        order: 'desc',
      },
    },
    {
      name: `${t('hardware-list.filter-selector-options.hashrate-asc')}`,
      filter: {
        key: 'minerModelHashratePerTerahash',
        order: 'asc',
      },
    },
    {
      name: `${t('hardware-list.filter-selector-options.hashrate-desc')}`,
      filter: {
        key: 'minerModelHashratePerTerahash',
        order: 'desc',
      },
    },
    {
      name: `${t(
        'hardware-list.filter-selector-options.price-per-hashrate-asc'
      )}`,
      filter: {
        key: 'productPricePerHashrate',
        order: 'asc',
      },
    },
    {
      name: `${t(
        'hardware-list.filter-selector-options.price-per-hashrate-desc'
      )}`,
      filter: {
        key: 'productPricePerHashrate',
        order: 'desc',
      },
    },
  ]

  useEffect(() => {
    return setHardwares(items)
  }, [items])

  // type OrderByProps
  useEffect(() => {
    if (!items) return
    const newHardwares = orderBy<Array<IMiner>>(
      [...items],
      sort.key,
      sort.order
    )
    setHardwares(newHardwares)
  }, [sort, items])

  return (
    <>
      <Stack spacing={4}>
        <Select
          fontSize={'15px'}
          mb={'5px'}
          variant="outline"
          color={'gray.500'}
          borderColor={'none'}
          size="md"
          _focus={{
            outline: 'none',
            boxShadow: 'none',
            borderColor: 'none',
            border: ' none',
          }}
          onChange={(e) => {
            setSort(
              (sortOptions &&
                sortOptions.find((option) => {
                  return (
                    `${option.filter.key}${option.filter.order}` ===
                    e.target.value
                  )
                })?.filter) || {
                key: 'minerModelHashratePerTerahash',
                order: 'asc',
              }
            )
          }}
          value={`${sort.key}${sort.order}`}
        >
          {sortOptions.map((option, index) => {
            return (
              <option
                key={index}
                value={`${option.filter.key}${option.filter.order}`}
              >
                {option.name}
              </option>
            )
          })}
        </Select>
      </Stack>
      {hardwares &&
        hardwares.length > 0 &&
        hardwares?.map((hardwareItem: IMinerNode, index: number) => {
          return (
            <FacilityMobileDetailCard hardwareItem={hardwareItem} key={index} />
          )
        })}
    </>
  )
}

export default FacilityDetailCard
